import {
  type JobEvent_Simulation_Read,
  type JobEventName,
  type JobEventSource,
  type JobState,
} from '@treadinc/horizon-api-spec';
import dayjs, { type Dayjs } from 'dayjs';

export class JobEventSimulation {
  constructor(
    private _id: string | null,
    private _state: JobState,
    private _occurred_at: Dayjs,
    private _event_name: JobEventName,
    private _event_source: JobEventSource,
    private _load_id: string | null,
    private _load_resource_id: string | null,
  ) {}

  public get id() {
    return this._id;
  }

  public get state() {
    return this._state;
  }

  public get occurredAt() {
    return this._occurred_at;
  }

  public get eventName() {
    return this._event_name;
  }

  public get eventSource() {
    return this._event_source;
  }

  public get loadId() {
    return this._load_id;
  }

  public get loadResourceId() {
    return this._load_resource_id;
  }

  public static parse(proto: JobEvent_Simulation_Read) {
    return new JobEventSimulation(
      proto.id ?? null,
      proto.state,
      dayjs(proto.occurred_at),
      proto.event_name,
      proto.event_source,
      proto.load?.load_id ?? null,
      proto.load?.id ?? null,
    );
  }
}
